import { Screen } from '~/screens/StressAssessments/UserResult';

export const StressAssessmentsUserResult: React.FC = () => <Screen />;
